"use strict";

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
/* global window */

var lib_1 = require("./lib");
var Client_1 = require("./Client");
var settings_1 = require("./settings");
exports.KEY = settings_1.SMART_KEY;
var debug = lib_1.debug.extend("oauth2");
function isBrowser() {
  return typeof window === "object";
}
/**
 * Fetches the well-known json file from the given base URL.
 * Note that the result is cached in memory (until the page is reloaded in the
 * browser) because it might have to be re-used by the client
 * @param baseUrl The base URL of the FHIR server
 */

function fetchWellKnownJson() {
  var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var requestOptions = arguments.length > 1 ? arguments[1] : undefined;
  var url = String(baseUrl).replace(/\/*$/, "/") + ".well-known/smart-configuration";
  return lib_1.getAndCache(url, requestOptions).catch(function (ex) {
    throw new Error("Failed to fetch the well-known json \"".concat(url, "\". ").concat(ex.message));
  });
}
exports.fetchWellKnownJson = fetchWellKnownJson;
/**
 * Fetch a "WellKnownJson" and extract the SMART endpoints from it
 */

function getSecurityExtensionsFromWellKnownJson() {
  var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var requestOptions = arguments.length > 1 ? arguments[1] : undefined;
  return fetchWellKnownJson(baseUrl, requestOptions).then(function (meta) {
    if (!meta.authorization_endpoint || !meta.token_endpoint) {
      throw new Error("Invalid wellKnownJson");
    }
    return {
      registrationUri: meta.registration_endpoint || "",
      authorizeUri: meta.authorization_endpoint,
      tokenUri: meta.token_endpoint
    };
  });
}
/**
 * Fetch a `CapabilityStatement` and extract the SMART endpoints from it
 */

function getSecurityExtensionsFromConformanceStatement() {
  var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var requestOptions = arguments.length > 1 ? arguments[1] : undefined;
  return lib_1.fetchConformanceStatement(baseUrl, requestOptions).then(function (meta) {
    var nsUri = "http://fhir-registry.smarthealthit.org/StructureDefinition/oauth-uris";
    var extensions = (lib_1.getPath(meta || {}, "rest.0.security.extension") || []).filter(function (e) {
      return e.url === nsUri;
    }).map(function (o) {
      return o.extension;
    })[0];
    var out = {
      registrationUri: "",
      authorizeUri: "",
      tokenUri: ""
    };
    if (extensions) {
      extensions.forEach(function (ext) {
        if (ext.url === "register") {
          out.registrationUri = ext.valueUri;
        }
        if (ext.url === "authorize") {
          out.authorizeUri = ext.valueUri;
        }
        if (ext.url === "token") {
          out.tokenUri = ext.valueUri;
        }
      });
    }
    return out;
  });
}
/**
 * This works similarly to `Promise.any()`. The tasks are objects containing a
 * request promise and it's AbortController. Returns a promise that will be
 * resolved with the return value of the first successful request, or rejected
 * with an aggregate error if all tasks fail. Any requests, other than the first
 * one that succeeds will be aborted.
 */

function any(tasks) {
  var len = tasks.length;
  var errors = [];
  var resolved = false;
  return new Promise(function (resolve, reject) {
    function onSuccess(task, result) {
      task.complete = true;
      if (!resolved) {
        resolved = true;
        tasks.forEach(function (t) {
          if (!t.complete) {
            t.controller.abort();
          }
        });
        resolve(result);
      }
    }
    function onError(error) {
      if (errors.push(error) === len) {
        reject(new Error(errors.map(function (e) {
          return e.message;
        }).join("; ")));
      }
    }
    tasks.forEach(function (t) {
      t.promise.then(function (result) {
        return onSuccess(t, result);
      }, onError);
    });
  });
}
/**
 * Given a FHIR server, returns an object with it's Oauth security endpoints
 * that we are interested in. This will try to find the info in both the
 * `CapabilityStatement` and the `.well-known/smart-configuration`. Whatever
 * Arrives first will be used and the other request will be aborted.
 * @param [baseUrl] Fhir server base URL
 * @param [env] The Adapter
 */

function getSecurityExtensions(env) {
  var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/";
  var AbortController = env.getAbortController();
  var abortController1 = new AbortController();
  var abortController2 = new AbortController();
  return any([{
    controller: abortController1,
    promise: getSecurityExtensionsFromWellKnownJson(baseUrl, {
      signal: abortController1.signal
    })
  }, {
    controller: abortController2,
    promise: getSecurityExtensionsFromConformanceStatement(baseUrl, {
      signal: abortController2.signal
    })
  }]);
}
exports.getSecurityExtensions = getSecurityExtensions;
/**
 * Starts the SMART Launch Sequence.
 * > **IMPORTANT**:
 *   `authorize()` will end up redirecting you to the authorization server.
 *    This means that you should not add anything to the returned promise chain.
 *    Any code written directly after the authorize() call might not be executed
 *    due to that redirect!
 * @param env
 * @param [params]
 * @param [_noRedirect] If true, resolve with the redirect url without trying to redirect to it
 */
function authorize(_x) {
  return _authorize.apply(this, arguments);
}
function _authorize() {
  _authorize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(env) {
    var params,
      _noRedirect,
      redirect_uri,
      clientSecret,
      fakeTokenResponse,
      patientId,
      encounterId,
      client_id,
      target,
      width,
      height,
      completeInTarget,
      iss,
      launch,
      fhirServiceUrl,
      redirectUri,
      _params$scope,
      scope,
      clientId,
      url,
      storage,
      serverUrl,
      oldKey,
      stateKey,
      state,
      fullSessionStorageSupport,
      redirectUrl,
      extensions,
      redirectParams,
      win,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          params = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          _noRedirect = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
          // Obtain input
          redirect_uri = params.redirect_uri, clientSecret = params.clientSecret, fakeTokenResponse = params.fakeTokenResponse, patientId = params.patientId, encounterId = params.encounterId, client_id = params.client_id, target = params.target, width = params.width, height = params.height, completeInTarget = params.completeInTarget;
          iss = params.iss, launch = params.launch, fhirServiceUrl = params.fhirServiceUrl, redirectUri = params.redirectUri, _params$scope = params.scope, scope = _params$scope === void 0 ? "" : _params$scope, clientId = params.clientId;
          url = env.getUrl();
          storage = env.getStorage(); // For these three an url param takes precedence over inline option
          iss = url.searchParams.get("iss") || iss;
          fhirServiceUrl = url.searchParams.get("fhirServiceUrl") || fhirServiceUrl;
          launch = url.searchParams.get("launch") || launch;
          if (!clientId) {
            clientId = client_id;
          }
          if (!redirectUri) {
            redirectUri = redirect_uri;
          }
          if (!redirectUri) {
            redirectUri = env.relative(".");
          } else {
            redirectUri = env.relative(redirectUri);
          }
          serverUrl = String(iss || fhirServiceUrl || ""); // Validate input
          if (serverUrl) {
            _context.next = 15;
            break;
          }
          throw new Error("No server url found. It must be specified as `iss` or as " + "`fhirServiceUrl` parameter");
        case 15:
          if (iss) {
            debug("Making %s launch...", launch ? "EHR" : "standalone");
          } // append launch scope if needed

          if (launch && !scope.match(/launch/)) {
            scope += " launch";
          } // If `authorize` is called, make sure we clear any previous state (in case
          // this is a re-authorize)
          _context.next = 19;
          return storage.get(settings_1.SMART_KEY);
        case 19:
          oldKey = _context.sent;
          _context.next = 22;
          return storage.unset(oldKey);
        case 22:
          // create initial state
          stateKey = lib_1.randomString(16);
          state = {
            clientId: clientId,
            scope: scope,
            redirectUri: redirectUri,
            serverUrl: serverUrl,
            clientSecret: clientSecret,
            tokenResponse: {},
            key: stateKey,
            completeInTarget: completeInTarget
          };
          fullSessionStorageSupport = isBrowser() ? lib_1.getPath(env, "options.fullSessionStorageSupport") : true;
          if (!fullSessionStorageSupport) {
            _context.next = 28;
            break;
          }
          _context.next = 28;
          return storage.set(settings_1.SMART_KEY, stateKey);
        case 28:
          // fakeTokenResponse to override stuff (useful in development)

          if (fakeTokenResponse) {
            Object.assign(state.tokenResponse, fakeTokenResponse);
          } // Fixed patientId (useful in development)

          if (patientId) {
            Object.assign(state.tokenResponse, {
              patient: patientId
            });
          } // Fixed encounterId (useful in development)

          if (encounterId) {
            Object.assign(state.tokenResponse, {
              encounter: encounterId
            });
          }
          redirectUrl = redirectUri + "?state=" + encodeURIComponent(stateKey); // bypass oauth if fhirServiceUrl is used (but iss takes precedence)
          if (!(fhirServiceUrl && !iss)) {
            _context.next = 41;
            break;
          }
          debug("Making fake launch...");
          _context.next = 36;
          return storage.set(stateKey, state);
        case 36:
          if (!_noRedirect) {
            _context.next = 38;
            break;
          }
          return _context.abrupt("return", redirectUrl);
        case 38:
          _context.next = 40;
          return env.redirect(redirectUrl);
        case 40:
          return _context.abrupt("return", _context.sent);
        case 41:
          _context.next = 43;
          return getSecurityExtensions(env, serverUrl);
        case 43:
          extensions = _context.sent;
          Object.assign(state, extensions);
          _context.next = 47;
          return storage.set(stateKey, state);
        case 47:
          if (state.authorizeUri) {
            _context.next = 53;
            break;
          }
          if (!_noRedirect) {
            _context.next = 50;
            break;
          }
          return _context.abrupt("return", redirectUrl);
        case 50:
          _context.next = 52;
          return env.redirect(redirectUrl);
        case 52:
          return _context.abrupt("return", _context.sent);
        case 53:
          // build the redirect uri
          redirectParams = ["response_type=code", "client_id=" + encodeURIComponent(clientId || ""), "scope=" + encodeURIComponent(scope), "redirect_uri=" + encodeURIComponent(redirectUri), "aud=" + encodeURIComponent(serverUrl), "state=" + encodeURIComponent(stateKey)]; // also pass this in case of EHR launch
          if (launch) {
            redirectParams.push("launch=" + encodeURIComponent(launch));
          }
          redirectUrl = state.authorizeUri + "?" + redirectParams.join("&");
          if (!_noRedirect) {
            _context.next = 58;
            break;
          }
          return _context.abrupt("return", redirectUrl);
        case 58:
          if (!(target && isBrowser())) {
            _context.next = 67;
            break;
          }
          _context.next = 61;
          return lib_1.getTargetWindow(target, width, height);
        case 61:
          win = _context.sent;
          if (win !== self) {
            try {
              // Also remove any old state from the target window and then
              // transfer the current state there
              win.sessionStorage.removeItem(oldKey);
              win.sessionStorage.setItem(stateKey, JSON.stringify(state));
            } catch (ex) {
              lib_1.debug("Failed to modify window.sessionStorage. Perhaps it is from different origin?. Failing back to \"_self\". %s", ex);
              win = self;
            }
          }
          if (win !== self) {
            try {
              win.location.href = redirectUrl;
              self.addEventListener("message", onMessage);
            } catch (ex) {
              lib_1.debug("Failed to modify window.location. Perhaps it is from different origin?. Failing back to \"_self\". %s", ex);
              self.location.href = redirectUrl;
            }
          } else {
            self.location.href = redirectUrl;
          }
          return _context.abrupt("return");
        case 67:
          _context.next = 69;
          return env.redirect(redirectUrl);
        case 69:
          return _context.abrupt("return", _context.sent);
        case 70:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _authorize.apply(this, arguments);
}
exports.authorize = authorize;
/**
 * Checks if called within a frame. Only works in browsers!
 * If the current window has a `parent` or `top` properties that refer to
 * another window, returns true. If trying to access `top` or `parent` throws an
 * error, returns true. Otherwise returns `false`.
 */

function isInFrame() {
  try {
    return self !== top && parent !== self;
  } catch (e) {
    return true;
  }
}
exports.isInFrame = isInFrame;
/**
 * Checks if called within another window (popup or tab). Only works in browsers!
 * To consider itself called in a new window, this function verifies that:
 * 1. `self === top` (not in frame)
 * 2. `!!opener && opener !== self` The window has an opener
 * 3. `!!window.name` The window has a `name` set
 */

function isInPopUp() {
  try {
    return self === top && !!opener && opener !== self && !!window.name;
  } catch (e) {
    return false;
  }
}
exports.isInPopUp = isInPopUp;
/**
 * Another window can send a "completeAuth" message to this one, making it to
 * navigate to e.data.url
 * @param e The message event
 */

function onMessage(e) {
  if (e.data.type == "completeAuth" && e.origin === new URL(self.location.href).origin) {
    window.removeEventListener("message", onMessage);
    window.location.href = e.data.url;
  }
}
exports.onMessage = onMessage;
/**
 * The completeAuth function should only be called on the page that represents
 * the redirectUri. We typically land there after a redirect from the
 * authorization server..
 */
function completeAuth(_x2) {
  return _completeAuth.apply(this, arguments);
}
function _completeAuth() {
  _completeAuth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(env) {
    var _a, _b, _c, _d, url, Storage, params, key, code, authError, authErrorDescription, state, fullSessionStorageSupport, inFrame, inPopUp, href, origin, hasState, authorized, requestOptions, tokenResponse, client;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          url = env.getUrl();
          Storage = env.getStorage();
          params = url.searchParams;
          key = params.get("state");
          code = params.get("code");
          authError = params.get("error");
          authErrorDescription = params.get("error_description");
          if (key) {
            _context2.next = 11;
            break;
          }
          _context2.next = 10;
          return Storage.get(settings_1.SMART_KEY);
        case 10:
          key = _context2.sent;
        case 11:
          if (!(authError || authErrorDescription)) {
            _context2.next = 13;
            break;
          }
          throw new Error([authError, authErrorDescription].filter(Boolean).join(": "));
        case 13:
          debug("key: %s, code: %O", key, code); // key might be coming from the page url so it might be empty or missing
          if (key) {
            _context2.next = 16;
            break;
          }
          throw new Error("No 'state' parameter found. Please (re)launch the app.");
        case 16:
          _context2.next = 18;
          return Storage.get(key);
        case 18:
          state = _context2.sent;
          fullSessionStorageSupport = isBrowser() ? lib_1.getPath(env, "options.fullSessionStorageSupport") : true; // If we are in a popup window or an iframe and the authorization is
          // complete, send the location back to our opener and exit.
          if (!(isBrowser() && state && !state.completeInTarget)) {
            _context2.next = 29;
            break;
          }
          inFrame = isInFrame();
          inPopUp = isInPopUp(); // we are about to return to the opener/parent where completeAuth will
          // be called again. In rare cases the opener or parent might also be
          // a frame or popup. Then inFrame or inPopUp will be true but we still
          // have to stop going up the chain. To guard against that weird form of
          // recursion we pass one additional parameter to the url which we later
          // remove.
          if (!((inFrame || inPopUp) && !url.searchParams.get("complete"))) {
            _context2.next = 29;
            break;
          }
          url.searchParams.set("complete", "1");
          href = url.href, origin = url.origin;
          if (inFrame) {
            parent.postMessage({
              type: "completeAuth",
              url: href
            }, origin);
          }
          if (inPopUp) {
            opener.postMessage({
              type: "completeAuth",
              url: href
            }, origin);
            window.close();
          }
          return _context2.abrupt("return", new Promise(function () {}));
        case 29:
          url.searchParams.delete("complete"); // Do we have to remove the `code` and `state` params from the URL?
          hasState = params.has("state");
          if (isBrowser() && lib_1.getPath(env, "options.replaceBrowserHistory") && (code || hasState)) {
            // `code` is the flag that tell us to request an access token.
            // We have to remove it, otherwise the page will authorize on
            // every load!
            if (code) {
              params.delete("code");
              debug("Removed code parameter from the url.");
            } // If we have `fullSessionStorageSupport` it means we no longer
            // need the `state` key. It will be stored to a well know
            // location - sessionStorage[SMART_KEY]. However, no
            // fullSessionStorageSupport means that this "well know location"
            // might be shared between windows and tabs. In this case we
            // MUST keep the `state` url parameter.

            if (hasState && fullSessionStorageSupport) {
              params.delete("state");
              debug("Removed state parameter from the url.");
            } // If the browser does not support the replaceState method for the
            // History Web API, the "code" parameter cannot be removed. As a
            // consequence, the page will (re)authorize on every load. The
            // workaround is to reload the page to new location without those
            // parameters. If that is not acceptable replaceBrowserHistory
            // should be set to false.

            if (window.history.replaceState) {
              window.history.replaceState({}, "", url.href);
            }
          } // If the state does not exist, it means the page has been loaded directly.
          if (state) {
            _context2.next = 34;
            break;
          }
          throw new Error("No state found! Please (re)launch the app.");
        case 34:
          // Assume the client has already completed a token exchange when
          // there is no code (but we have a state) or access token is found in state
          authorized = !code || ((_b = (_a = state) === null || _a === void 0 ? void 0 : _a.tokenResponse) === null || _b === void 0 ? void 0 : _b.access_token); // If we are authorized already, then this is just a reload.
          // Otherwise, we have to complete the code flow
          if (!(!authorized && state.tokenUri)) {
            _context2.next = 53;
            break;
          }
          if (code) {
            _context2.next = 38;
            break;
          }
          throw new Error("'code' url parameter is required");
        case 38:
          debug("Preparing to exchange the code for access token...");
          requestOptions = buildTokenRequest(env, code, state);
          debug("Token request options: %O", requestOptions); // The EHR authorization server SHALL return a JSON structure that
          // includes an access token or a message indicating that the
          // authorization request has been denied.
          _context2.next = 43;
          return lib_1.request(state.tokenUri, requestOptions);
        case 43:
          tokenResponse = _context2.sent;
          debug("Token response: %O", tokenResponse);
          if (tokenResponse.access_token) {
            _context2.next = 47;
            break;
          }
          throw new Error("Failed to obtain access token.");
        case 47:
          // save the tokenResponse so that we don't have to re-authorize on
          // every page reload

          state = Object.assign(Object.assign({}, state), {
            tokenResponse: tokenResponse
          });
          _context2.next = 50;
          return Storage.set(key, state);
        case 50:
          debug("Authorization successful!");
          _context2.next = 54;
          break;
        case 53:
          debug(((_d = (_c = state) === null || _c === void 0 ? void 0 : _c.tokenResponse) === null || _d === void 0 ? void 0 : _d.access_token) ? "Already authorized" : "No authorization needed");
        case 54:
          if (!fullSessionStorageSupport) {
            _context2.next = 57;
            break;
          }
          _context2.next = 57;
          return Storage.set(settings_1.SMART_KEY, key);
        case 57:
          client = new Client_1.default(env, state);
          debug("Created client instance: %O", client);
          return _context2.abrupt("return", client);
        case 60:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _completeAuth.apply(this, arguments);
}
exports.completeAuth = completeAuth;
/**
 * Builds the token request options. Does not make the request, just
 * creates it's configuration and returns it in a Promise.
 */

function buildTokenRequest(env, code, state) {
  var redirectUri = state.redirectUri,
    clientSecret = state.clientSecret,
    tokenUri = state.tokenUri,
    clientId = state.clientId;
  if (!redirectUri) {
    throw new Error("Missing state.redirectUri");
  }
  if (!tokenUri) {
    throw new Error("Missing state.tokenUri");
  }
  if (!clientId) {
    throw new Error("Missing state.clientId");
  }
  var requestOptions = {
    method: "POST",
    headers: {
      "content-type": "application/x-www-form-urlencoded"
    },
    body: "code=".concat(code, "&grant_type=authorization_code&redirect_uri=").concat(encodeURIComponent(redirectUri))
  }; // For public apps, authentication is not possible (and thus not required),
  // since a client with no secret cannot prove its identity when it issues a
  // call. (The end-to-end system can still be secure because the client comes
  // from a known, https protected endpoint specified and enforced by the
  // redirect uri.) For confidential apps, an Authorization header using HTTP
  // Basic authentication is required, where the username is the app’s
  // client_id and the password is the app’s client_secret (see example).

  if (clientSecret) {
    requestOptions.headers.Authorization = "Basic " + env.btoa(clientId + ":" + clientSecret);
    debug("Using state.clientSecret to construct the authorization header: %s", requestOptions.headers.Authorization);
  } else {
    debug("No clientSecret found in state. Adding the clientId to the POST body");
    requestOptions.body += "&client_id=".concat(encodeURIComponent(clientId));
  }
  return requestOptions;
}
exports.buildTokenRequest = buildTokenRequest;
/**
 * @param env
 * @param [onSuccess]
 * @param [onError]
 */
function ready(_x3, _x4, _x5) {
  return _ready.apply(this, arguments);
}
function _ready() {
  _ready = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(env, onSuccess, onError) {
    var task;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          task = completeAuth(env);
          if (onSuccess) {
            task = task.then(onSuccess);
          }
          if (onError) {
            task = task.catch(onError);
          }
          return _context3.abrupt("return", task);
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _ready.apply(this, arguments);
}
exports.ready = ready;
/**
 * This function can be used when you want to handle everything in one page
 * (no launch endpoint needed). You can think of it as if it does:
 * ```js
 * authorize(options).then(ready)
 * ```
 *
 * **Be careful with init()!** There are some details you need to be aware of:
 *
 * 1. It will only work if your launch_uri is the same as your redirect_uri.
 *    While this should be valid, we can’t promise that every EHR will allow you
 *    to register client with such settings.
 * 2. Internally, `init()` will be called twice. First it will redirect to the
 *    EHR, then the EHR will redirect back to the page where init() will be
 *    called again to complete the authorization. This is generally fine,
 *    because the returned promise will only be resolved once, after the second
 *    execution, but please also consider the following:
 *    - You should wrap all your app’s code in a function that is only executed
 *      after `init()` resolves!
 *    - Since the page will be loaded twice, you must be careful if your code
 *      has global side effects that can persist between page reloads
 *      (for example writing to localStorage).
 * 3. For standalone launch, only use init in combination with offline_access
 *    scope. Once the access_token expires, if you don’t have a refresh_token
 *    there is no way to re-authorize properly. We detect that and delete the
 *    expired access token, but it still means that the user will have to
 *    refresh the page twice to re-authorize.
 * @param env The adapter
 * @param options The authorize options
 */
function init(_x6, _x7) {
  return _init.apply(this, arguments);
}
function _init() {
  _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(env, options) {
    var url, code, state, storage, key, cached;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          url = env.getUrl();
          code = url.searchParams.get("code");
          state = url.searchParams.get("state"); // if `code` and `state` params are present we need to complete the auth flow
          if (!(code && state)) {
            _context4.next = 5;
            break;
          }
          return _context4.abrupt("return", completeAuth(env));
        case 5:
          // Check for existing client state. If state is found, it means a client
          // instance have already been created in this session and we should try to
          // "revive" it.
          storage = env.getStorage();
          _context4.t0 = state;
          if (_context4.t0) {
            _context4.next = 11;
            break;
          }
          _context4.next = 10;
          return storage.get(settings_1.SMART_KEY);
        case 10:
          _context4.t0 = _context4.sent;
        case 11:
          key = _context4.t0;
          _context4.next = 14;
          return storage.get(key);
        case 14:
          cached = _context4.sent;
          if (!cached) {
            _context4.next = 17;
            break;
          }
          return _context4.abrupt("return", new Client_1.default(env, cached));
        case 17:
          return _context4.abrupt("return", authorize(env, options).then(function () {
            // `init` promises a Client but that cannot happen in this case. The
            // browser will be redirected (unload the page and be redirected back
            // to it later and the same init function will be called again). On
            // success, authorize will resolve with the redirect url but we don't
            // want to return that from this promise chain because it is not a
            // Client instance. At the same time, if authorize fails, we do want to
            // pass the error to those waiting for a client instance.
            return new Promise(function () {});
          }));
        case 18:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _init.apply(this, arguments);
}
exports.init = init;